import _ from "lodash"

const defaultColumns = [
  {
    width: 60,
    title: '序号',
    align: 'left',
    show: true,
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '站点Id',
    dataIndex: 'spiderId',
    show: true,
    align: 'left',
    scopedSlots: { customRender: 'spiderId' }
  },
  {
    title: '站点名称',
    dataIndex: 'spiderName',
    show: true,
    align: 'left',
    scopedSlots: { customRender: 'spiderName' }
  },
  {
    title: '站点类型',
    dataIndex: 'spiderClassId',
    show: true,
    align: 'left',
    scopedSlots: { customRender: 'spiderClassId' }
  },
  {
    title: '申请人',
    dataIndex: 'applyName',
    show: true,
    align: 'left'
  },
  {
    title: '申请时间',
    dataIndex: 'createTime',
    show: true,
    align: 'left',
  },

];

const actionCell = {
  title: '操作',
  dataIndex: 'action',
  scopedSlots: { customRender: 'action' },
  show: true,
  align: 'left',
  width: 220
};

const examineUser = {
  title: '审核人',
  dataIndex: 'examineName',
  show: true,
  align: 'left'
}

const examineTime = {
  title: '审核时间',
  dataIndex: 'examineTime',
  show: true,
  align: 'left'
}

// 待审核
export const toBeReviewedColumns = [
  ..._.cloneDeep(defaultColumns),
  _.cloneDeep(actionCell)
];



// 已通过
export const reviewedColumns = [
  ..._.cloneDeep(defaultColumns),
  _.cloneDeep(examineUser),
  _.cloneDeep(examineTime),
  _.cloneDeep(actionCell)
]


// 已驳回
export const rejectColumns = [
  ..._.cloneDeep(defaultColumns),
  _.cloneDeep(examineUser),
  _.cloneDeep(examineTime),
  _.cloneDeep(actionCell)
]

// 已经删除
export const deletedColumns = [
  ..._.cloneDeep(defaultColumns),
  _.cloneDeep(examineUser),
  _.cloneDeep(examineTime),
  _.cloneDeep(actionCell)
]